module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesUrban.a8a455f.jpg";